import { All, Query } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { dataRequested, updateUi } from "../common/actions";
import { dataLoaded } from "../common/actions";
import { receiveResultsFailure } from "../common/actions";
import BankFind from "../components/BankFind/BankFind";
import { initialAppState } from "../common/reducers/appState";

export function mapStateToProps({ appState, ui }: All) {
  return {
    appState: appState.bankFind as Query,
    dataLoaded: ui.dataLoaded,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onStartRequest: () => {
      dispatch(dataRequested());
    },
    updateUi: (uiField: string, uiValue: string | undefined) => {
      dispatch(updateUi(uiField, uiValue));
    },
    resetState: () => {
      dispatch(actions.resetState(initialAppState.bankFind));
    },
    onResultSuccess: () => {
      dispatch(dataLoaded());
    },
    onResultFailure: (error: any) => dispatch(receiveResultsFailure(error)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BankFind);
